import { mapGetters, mapActions } from 'vuex';
export default {
    data() {
        return {

        }
    },
    computed:
        mapGetters([
            'getAccount',
            'getIsLoadingAccount',
        ]),
    //Mixin lifecycle hooks are called on any component that includes them
    mounted() {
       
        // if (this.getAccount == null && !this.getIsLoadingAccount)
        //     this.fetchAccount(); // This will 401 if still not logged in causing re-direct via the axios intercepter
    },
    methods: {
        ...mapActions([
            'fetchAccount',
        ]),

    }
}